import LoyaltyProgramHandlerSFC from "./LoyaltyProgramHandler.vue";
export const LoyaltyProgramHandler = LoyaltyProgramHandlerSFC;
